<template>
  <transition name="modal">
    <div v-if="action" class="modal-mask" :class="{ 'row-block': isMobile, 'mobile': isMobile }" @click.stop="e => closeModal()">
      <div class="modal-wrapper col-block" :class="[{ 'auto-height': autoHeight }, type]">
        <div :style="{ flex: 1 }"></div>
        <div class="modal-container" :style="containerStyle" @click.stop>
          <slot></slot>
          <dialogLoading v-if="isDialogLoading"></dialogLoading>
        </div>
        <div :style="{ flex: 2, 'min-height': '0.1px', 'width': '100%' }"></div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import dialogLoading from './loading.vue'
import responsitive from '../../mixins/responsitive.vue'

export default {
  components: {
    dialogLoading
  },
  mixins: [
    responsitive
  ],
  props: {
    action: {
      type: String,
      default: () => null
    },
    type: {
      type: String,
      default: () => 'default'
    },
    width: {
      type: String,
      default: () => null
    },
    height: {
      type: String,
      default: () => null
    },
    customStyles: {
      type: Object,
      default: () => ({})
    },
    maskClose: {
      type: Boolean,
      default: () => true
    },
    autoHeight: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      onClose: false
    }
  },
  computed: {
    ...mapGetters([
      'isDialogLoading'
    ]),
    containerStyle () {
      let defaultStyle = {
        'default': {
          height: this.height || 'auto',
          width: this.width || '400px'
        },
        'slide-left': {
          height: null,
          width: this.width || '80%'
        },
        'slide-right': {
          height: null,
          width: this.width || '80%'
        }
      }[this.type]
      return { ...this.customStyles, ...defaultStyle }
    }
  },
  methods: {
    closeModal () {
      if (this.maskClose) {
        this.$emit('hide')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  .modal-mask
    position: fixed
    height: 100vh
    overflow-y: auto
    overflow-x: hidden
    z-index: 9996
    top: 0
    left: 0
    width: 100%
    min-height: 100%
    background: rgba(51, 51, 51, 0.6)
    transition: opacity .3s ease
    &::-webkit-scrollbar
      height: 0
    &.mobile
      .modal-wrapper
        .modal-container
          margin: 10px auto 10px
  .modal-wrapper
    width: 100%
    height: 100%
    vertical-align: middle
    &.auto-height
      height: auto
    &.slide-left
      align-items: flex-start
    &.slide-right
      align-items: flex-end
    &.slide-left, &.slide-right
      height: 100%
      .modal-container
        height: 100%
        margin: 0 !important
        border-radius: 0
        height: var(--window-height)
        transition: all .5s ease
    .modal-container
      position: relative
      max-width: calc(100% - 40px)
      margin: 60px auto
      padding: 20px
      background: white
      border-radius: 20px
      box-shadow: 0 3px 6px rgba(0, 0, 0, .16)
      box-sizing: border-box
      transition: all .3s ease
  .modal-enter
    opacity: 0
  .modal-leave-active
    opacity: 0
  .modal-enter .modal-container
    transform: scale(1.1)
  .modal-leave-active .modal-container
    transform: scale(1.1)
  .modal-enter .modal-wrapper.slide-left .modal-container
    transform: translateX(-50%)
  .modal-leave-active .modal-wrapper.slide-left .modal-container
    transform: translateX(-50%)
  .modal-enter .modal-wrapper.slide-right .modal-container
    transform: translateX(50%)
  .modal-leave-active .modal-wrapper.slide-right .modal-container
    transform: translateX(50%)
</style>



// WEBPACK FOOTER //
// src/components/dialog/container.vue